export * from './doc-details'
